/**
 * Dessins en pixels du thème Arcade (un caractère = un pixel, « # » plein, « . » vide). Dessins originaux : des petits
 * extraterrestres génériques et des blocs, aucun personnage ni sprite d'un jeu existant.
 */
export const EXTRATERRESTRES = [
    [
        "..#....#..",
        "...#..#...",
        "..######..",
        ".##.##.##.",
        "##########",
        "#.######.#",
        "#.#....#.#",
        "...#..#...",
    ],
    [
        "...####...",
        ".########.",
        "##########",
        "##.####.##",
        "##########",
        "..##..##..",
        ".##.##.##.",
        "##......##",
    ],
    [
        "#........#",
        ".#.####.#.",
        ".########.",
        "###.##.###",
        "##########",
        ".########.",
        "..#....#..",
        ".#......#.",
    ],
];

/** Pièces de blocs (quatre carrés, toutes les orientations utiles), en coordonnées {x, y}. */
export const BLOCS = [
    [[0, 0], [1, 0], [2, 0], [3, 0]],
    [[0, 0], [1, 0], [0, 1], [1, 1]],
    [[0, 0], [1, 0], [2, 0], [1, 1]],
    [[1, 0], [2, 0], [0, 1], [1, 1]],
    [[0, 0], [1, 0], [1, 1], [2, 1]],
    [[0, 0], [0, 1], [1, 1], [2, 1]],
    [[2, 0], [0, 1], [1, 1], [2, 1]],
];

/** Rectangles « x y largeur » d'un dessin, ligne par ligne (une série de pixels voisins = un seul rectangle). */
export function rectangles(dessin) {
    const sortie = [];
    dessin.forEach((ligne, y) => {
        let debut = -1;
        for (let x = 0; x <= ligne.length; x++) {
            const plein = ligne[x] === "#";
            if (plein && debut < 0) debut = x;
            if (!plein && debut >= 0) { sortie.push({x: debut, y, l: x - debut}); debut = -1; }
        }
    });
    return sortie;
}

/** Générateur pseudo-aléatoire à graine (mêmes tirages partout, rien ne change d'un affichage à l'autre). */
export function graine(depart) {
    let s = depart >>> 0 || 1;
    return () => {
        s = (Math.imul(s, 1664525) + 1013904223) >>> 0;
        return s / 4294967296;
    };
}
